import React, { createContext, useContext, useState, useCallback } from 'react';

const RegionContext = createContext({
  region: null,
  setRegion: () => {},
  clearRegion: () => {},
  regionLabel: '',
});

export const useRegion = () => useContext(RegionContext);

const REGION_LABELS = {
  NA: 'North America',
  UK_EMEA: 'UK & EMEA',
  APAC: 'APAC',
};

export const getRegionLabel = (key) => REGION_LABELS[key] || key;

export const RegionProvider = ({ children }) => {
  const [region, setRegionState] = useState(() => {
    if (typeof window !== 'undefined') {
      return sessionStorage.getItem('hf_region') || null;
    }
    return null;
  });

  const setRegion = useCallback((r) => {
    sessionStorage.setItem('hf_region', r);
    setRegionState(r);
  }, []);

  const clearRegion = useCallback(() => {
    sessionStorage.removeItem('hf_region');
    setRegionState(null);
  }, []);

  return (
    <RegionContext.Provider value={{
      region,
      setRegion,
      clearRegion,
      regionLabel: region ? REGION_LABELS[region] || region : '',
    }}>
      {children}
    </RegionContext.Provider>
  );
};
